import * as yup from 'yup';

const schema = yup.object().shape({
  countryId: yup.string().required(),
  inStandard: yup.number(),
  outStandard: yup.number(),
  inReefer: yup.number(),
  outReefer: yup.number(),
});

export default schema;
